export const airplane = {
  viewBox: "0 0 512 512",
  path: (
    <>
      <path d="M186.62,464H160a16,16,0,0,1-14.57-22.6l64.46-142.25L113.1,297,77.8,339.77C71.07,348.23,65.7,352,52,352H34.08a17.66,17.66,0,0,1-14.7-7.06c-2.38-3.21-4.72-8.65-2.44-16.41l19.82-71c.15-.53.33-1.06.53-1.58a.38.38,0,0,0,0-.15,14.82,14.82,0,0,1-.53-1.59L16.92,182.76c-2.15-7.61.2-12.93,2.56-16.06a16.83,16.83,0,0,1,13.6-6.7H52c10.23,0,20.16,4.59,26,12l34.57,42.05,97.32-1.44-64.44-142A16,16,0,0,1,160,48h26.91a25,25,0,0,1,19.35,9.8l125.05,152,57.77-1.52c4.23-.23,15.95-.31,18.66-.31C463,208,496,225.94,496,256c0,9.46-3.78,27-29.07,38.16-14.93,6.6-34.85,9.94-59.21,9.94-2.68,0-14.37-.08-18.66-.31l-57.76-1.54-125.36,152A25,25,0,0,1,186.62,464Z" />
    </>
  ),
};

export const bus = {
  viewBox: "0 0 512 512",
  path: (
    <>
      <path d="M400,32H112A48,48,0,0,0,64,80V400a47.91,47.91,0,0,0,16,35.74V454a26,26,0,0,0,26,26h28a26,26,0,0,0,26-26v-6H352v6a26,26,0,0,0,26,26h28a26,26,0,0,0,26-26V435.74A47.91,47.91,0,0,0,448,400V80A48,48,0,0,0,400,32ZM147.47,399.82a32,32,0,1,1,28.35-28.35A32,32,0,0,1,147.47,399.82ZM236,288H112a16,16,0,0,1-16-16V144a16,16,0,0,1,16-16H236a4,4,0,0,1,4,4V284A4,4,0,0,1,236,288ZM256,96H112.46c-8.6,0-16-6.6-16.44-15.19A16,16,0,0,1,112,64H399.54c8.6,0,16,6.6,16.44,15.19A16,16,0,0,1,400,96H256Zm20,32H400a16,16,0,0,1,16,16V272a16,16,0,0,1-16,16H276a4,4,0,0,1-4-4V132A4,4,0,0,1,276,128Zm60.18,243.47a32,32,0,1,1,28.35,28.35A32,32,0,0,1,336.18,371.47Z" />
    </>
  ),
};

export const car = {
  viewBox: "0 0 512 512",
  path: (
    <>
      <path d="M447.68,220.78a16,16,0,0,0-1-3.08l-37.78-88.16C400.19,109.17,379,96,354.89,96H157.11c-24.09,0-45.3,13.17-54,33.54L65.29,217.7A15.72,15.72,0,0,0,64,224V400a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V384H384v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V224A16.15,16.15,0,0,0,447.68,220.78ZM144,320a32,32,0,1,1,32-32A32,32,0,0,1,144,320Zm224,0a32,32,0,1,1,32-32A32,32,0,0,1,368,320ZM104.26,208l28.23-65.85C136.11,133.69,146,128,157.11,128H354.89c11.1,0,21,5.69,24.62,14.15L407.74,208Z" />
    </>
  ),
};

export const train = {
  viewBox: "0 0 512 512",
  path: (
    <>
      <ellipse
        cx="256"
        cy="304"
        rx="32.05"
        ry="31.94"
        transform="translate(-139.98 270.06) rotate(-45)"
      />
      <path d="M352,32H337a10,10,0,0,1-7.87-3.78A31.94,31.94,0,0,0,304,16H208a32,32,0,0,0-26.11,13.52A6,6,0,0,1,177,32H160c-36.81,0-64,28.84-64,64V351c0,23.27,25.6,42.06,83,60.94a753,753,0,0,0,73.77,19.73,16,16,0,0,0,6.46,0A753,753,0,0,0,333,411.94c57.4-18.88,83-37.67,83-60.94V96A64,64,0,0,0,352,32ZM184,128H328a8,8,0,0,1,8,8v48a8,8,0,0,1-8,8H184a8,8,0,0,1-8-8V136A8,8,0,0,1,184,128Zm76.18,239.87a64,64,0,1,1,59.69-59.69A64.07,64.07,0,0,1,260.18,367.87Z" />
      <path d="M395.31,468.69,347.63,421c-6.09-6.1-16-6.66-22.38-.86a16,16,0,0,0-.56,23.16l4.68,4.69H182.63l4.36-4.37c6.1-6.09,6.66-16,.86-22.38a16,16,0,0,0-23.16-.56l-48,48a16,16,0,1,0,22.62,22.62L150.63,480H361.37l11.32,11.31a16,16,0,0,0,22.62-22.62Z" />
    </>
  ),
};

export const boat = {
  viewBox: "0 0 512 512",
  path: (
    <>
      <path d="M416,473.14a6.83,6.83,0,0,0-3.57-6c-27.07-14.55-51.76-36.82-62.62-48a10.05,10.05,0,0,0-12.72-1.51c-50.33,32.42-111.61,32.44-161.95.05a10.09,10.09,0,0,0-12.82,1.56c-10.77,11.28-35.19,33.3-62.43,47.75A7.11,7.11,0,0,0,96,472.72a6.73,6.73,0,0,0,7.92,7.15c20.85-4.18,41-13.68,60.2-23.83a8.71,8.71,0,0,1,8-.06,185.14,185.14,0,0,0,167.81,0,8.82,8.82,0,0,1,8.09.06c19.1,10,39.22,19.59,60,23.8a6.73,6.73,0,0,0,8-6.71Z" />
      <path d="M476.71,246.91h0c-3.49-8.39-10.9-14.89-20.9-18.35L432,219.08V136a64,64,0,0,0-64-64H336V64a40,40,0,0,0-40-40H216a40,40,0,0,0-40,40v8H144a64,64,0,0,0-64,64v83.15l-23.58,9.39c-9.94,3.3-17.63,10-21.15,18.44-2.45,5.89-5.25,15-1.3,26.46l.1.3L80.73,393.18A23.33,23.33,0,0,0,102.58,408c.5,0,1,0,1.53-.05,31.32-2,56-17.27,72.6-31.61C200.42,396.81,228.31,408,256,408s55.43-11.2,79.14-31.7c16.59,14.36,41.3,29.67,72.61,31.65a23.36,23.36,0,0,0,23.37-14.74l46.65-119C481.05,266.12,480.67,256.45,476.71,246.91ZM269,154.21l-1.14-.4a39.53,39.53,0,0,0-23.73,0l-.58.18L117.48,204.22A4,4,0,0,1,112,200.5V136a32,32,0,0,1,32-32H368a32,32,0,0,1,32,32v64.44a4,4,0,0,1-5.48,3.72Z" />
    </>
  ),
};

export const layover = {
  viewBox: "0 0 48 48",
  path: (
    <>
      <path d="M23.99 4C12.94 4 4 12.95 4 24s8.94 20 19.99 20C35.04 44 44 35.05 44 24S35.04 4 23.99 4zM24 40c-8.84 0-16-7.16-16-16S15.16 8 24 8s16 7.16 16 16-7.16 16-16 16zm1-26h-3v12l10.49 6.3L34 29.84l-9-5.34z" />
    </>
  ),
};

export const tracks = {
  viewBox: "0 0 64 64",
  path: (
    <>
      <path d="M27.038 27.228c-4.433 7.974 7.948 13.905.962 16.892c-6.985 2.988-10.346-3.63-13.854-12.064c-3.51-8.434-.691-17.694 6.295-20.68c6.985-2.989 12.461 5.296 6.597 15.852"></path>
      <path d="M23.954 5.441c.015-2.33 1.574-3.457 3.486-3.441c1.911.014 3.453 1.162 3.436 3.492c-.023 3.334-1.584 4.961-3.495 4.948s-3.452-1.664-3.427-4.999"></path>
      <path d="M18.136 6.573c-.244-1.659.739-2.633 2.1-2.838c1.359-.207 2.581.436 2.824 2.094c.348 2.372-.582 3.704-1.942 3.909c-1.36.204-2.634-.794-2.982-3.165"></path>
      <path d="M13.859 9.45c-.393-1.414.358-2.373 1.52-2.703s2.293.092 2.686 1.508c.561 2.023-.105 3.285-1.267 3.615s-2.379-.397-2.939-2.42"></path>
      <path d="M11.549 13.44c-.447-1.043.028-1.857.884-2.234s1.768-.174 2.216.869c.638 1.492.261 2.529-.595 2.908c-.855.377-1.863-.051-2.505-1.543"></path>
      <path d="M10.137 16.909c-.357-.834.021-1.484.707-1.785c.684-.303 1.412-.141 1.771.693c.511 1.191.208 2.021-.477 2.324c-.683.301-1.489-.041-2.001-1.232"></path>
      <path d="M35.248 44.153c2.908 8.666-10.34 12.184-4.018 16.424c6.325 4.241 10.829-1.635 15.811-9.27c4.981-7.635 3.896-17.262-2.43-21.504c-6.323-4.24-13.211 2.882-9.363 14.35"></path>
      <path d="M42.236 23.317c.408-2.293-.919-3.692-2.801-4.036s-3.606.498-4.013 2.791c-.583 3.282.656 5.172 2.538 5.516c1.882.345 3.694-.989 4.276-4.271"></path>
      <path d="M47.749 25.515c.541-1.584-.248-2.727-1.548-3.182c-1.299-.457-2.615-.053-3.156 1.532c-.773 2.264-.101 3.748 1.198 4.203s2.734-.288 3.506-2.553"></path>
      <path d="M51.432 29.142c.642-1.318.078-2.4-1.002-2.941c-1.082-.541-2.271-.338-2.914.98c-.919 1.885-.494 3.248.587 3.791c1.08.541 2.409.054 3.329-1.83"></path>
      <path d="M52.975 33.495c.63-.941.311-1.832-.463-2.361c-.772-.531-1.705-.502-2.335.439c-.899 1.346-.716 2.438.058 2.969c.771.531 1.84.299 2.74-1.047"></path>
      <path d="M53.733 37.167c.503-.752.247-1.463-.37-1.887c-.618-.424-1.361-.4-1.866.352c-.719 1.076-.57 1.946.046 2.372c.616.424 1.471.238 2.19-.837"></path>
    </>
  ),
};
